import { enableClient } from '@wix/cli-app/internal/platform-sdk/site';

const { injectGetAccessToken: injectAccessTokenGetter } = enableClient('88110a9d-ba44-450e-bcf9-17058af00b76');

export { injectAccessTokenGetter };

export { default } from '/src/site/components/Background/component.tsx';
export * from '/src/site/components/Background/component.tsx';